import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
} from 'react-router-dom';

import AIPlayground from './admin/screens/AIPlayground/AIPlayground';
import FeeSchedulesScreen from './admin/screens/FeeSchedules/FeeSchedulesScreen';
import OrganizationCreateScreen from './admin/screens/OrganizationCreateScreen/OrganizationCreateScreen';
import OrganizationEditScreen from './admin/screens/OrganizationEditScreen/OrganizationEditScreen';
import OrganizationsScreen from './admin/screens/OrganizationsScreen/OrganizationsScreen';
import ResultDetailsScreen from './admin/screens/ResultDetailsScreen/ResultDetailsScreen';
import ResultsScreen from './admin/screens/ResultsScreen/ResultsScreen';
import UserProfileScreen from './admin/screens/UserProfileScreen/UserProfileScreen';
import UsersScreen from './admin/screens/UsersScreen/UsersScreen';
import { Footer } from './common/components/footer/footer';
import {
  AuthPAGES,
  ExternalPAGES,
  FlorencePAGES,
} from './common/components/tfa-auth/constants/pages';
import CheckPassword from './common/components/tfa-auth/pages/check-password/CheckPassword';
import { Layout } from './common/components/tfa-dashboard-layout/Layout';
import { Pages } from './common/constants/Pages';
import EditOPNoteScreen from './florence/screens/EditOPNoteScreenV2/EditOPNoteScreen';
import EditSheetScreen from './florence/screens/EditSheetScreen/EditSheetScreen';
import HomeScreen from './florence/screens/HomeScreen/HomeScreen';
import SavedSheetScreen from './florence/screens/SavedSheetScreen/SavedSheetScreen';
import ScanPackageScreen from './florence/screens/ScanPackageScreen/ScanPackageScreen';
import SearchResultsScreen from './florence/screens/SearchResultsScreen/SearchResultsScreen';
import SmartLaunchAuthScreen from './florence/screens/SmartLaunchScreen/SmartLaunchAuthScreen';
import SmartLaunchScreen from './florence/screens/SmartLaunchScreen/SmartLaunchScreen';
import SubscriptionScreen from './florence/screens/SubscriptionScreen/SubscriptionScreen';
import TFactorScreen from './florence/screens/TFactorScreen/TFactorScreen';

export const AdminRoutes = () => {
  return (
    <Router>
      <Layout
        hasAvatar={true}
        hasHeader={false}
        hasBurger={false}
        hasMail={false}
        hasNotification={false}
        hasSearch={false}
      >
        <Routes>
          <Route path='*' element={<Navigate to={Pages.results} replace />} />
          <Route path={Pages.results} element={<ResultsScreen />} />
          <Route path={Pages.result} element={<ResultDetailsScreen />} />
          <Route path={Pages.users} element={<UsersScreen />} />
          <Route path={Pages.user} element={<UserProfileScreen />} />
          <Route path={Pages.organizations} element={<OrganizationsScreen />} />
          <Route
            path={Pages.editOrganization}
            element={<OrganizationEditScreen />}
          />
          <Route
            path={Pages.createOrganization}
            element={<OrganizationCreateScreen />}
          />
          <Route path={FlorencePAGES.editSheet} element={<EditSheetScreen />} />
          <Route
            path={FlorencePAGES.editOPNote}
            element={<EditOPNoteScreen />}
          />

          <Route path={Pages.user} element={<UserProfileScreen />} />
          <Route path={Pages.AIplayground} element={<AIPlayground />} />
          <Route path={Pages.FeeSchedules} element={<FeeSchedulesScreen />} />
        </Routes>
      </Layout>
      <Footer />
    </Router>
  );
};

export const FlorenceRoutes = () => {
  return (
    <Router>
      <Layout
        hasAvatar={true}
        hasHeader={true}
        hasBurger={false}
        hasMail={false}
        hasNotification={false}
        hasSearch={false}
      >
        <Routes>
          <Route path={FlorencePAGES.home} element={<HomeScreen />} />
          <Route
            path={FlorencePAGES.results}
            element={<SearchResultsScreen />}
          />
          {/* <Route path={AuthPAGES.userProfile} element={<Profile />} />
            <Route
              path={`${AuthPAGES.verifyPhone}`}
              element={<VerifyPhone position="relative" top="25%" />}
            /> */}
          <Route
            path={`${AuthPAGES.checkPassword}/:type`}
            element={<CheckPassword position='relative' top='10%' />}
          />
          <Route
            path='*'
            element={<Navigate to={FlorencePAGES.home} replace />}
          />
          <Route
            path={FlorencePAGES.subscriptions}
            element={<SubscriptionScreen />}
          />
          <Route
            path={FlorencePAGES.scanPackage}
            element={<ScanPackageScreen />}
          />
          <Route path={FlorencePAGES.tFactorAuth} element={<TFactorScreen />} />
          <Route
            path={FlorencePAGES.savedSheet}
            element={<SavedSheetScreen />}
          />
          <Route path={FlorencePAGES.editSheet} element={<EditSheetScreen />} />
          <Route
            path={FlorencePAGES.editOPNote}
            element={<EditOPNoteScreen />}
          />
        </Routes>
      </Layout>
    </Router>
  );
};

export const SmartLaunchAuthRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route
          path={ExternalPAGES.smartLaunchAuth}
          element={<SmartLaunchAuthScreen />}
        />
        <Route
          path={ExternalPAGES.smartLaunch}
          element={<SmartLaunchScreen />}
        />
      </Routes>
    </Router>
  );
};
